import { merchantApi } from '@/config/axios'

/**
 * 商家端 — 店铺管理 API
 * 使用 merchantApi（baseURL 不含 /admin-api，商家 token 鉴权）
 */

// 获取当前商家店铺信息（壳层/归属用；缺权时静默，避免子账号刷「无权限」）
export const getShopInfo = (soft = false) => {
  return merchantApi.get({
    url: '/merchant-api/merchant/shop/get',
    ...(soft ? { headers: { ignoreError: true } } : {})
  })
}

// 更新店铺信息（含退货地址）
export const updateShop = (data: {
  shopName: string
  shopLogo?: string
  shopBanner?: string
  shopDesc?: string
  contactPhone?: string
  returnName: string
  returnMobile: string
  returnAreaId: number
  returnDetailAddress: string
}) => {
  return merchantApi.put({ url: '/merchant-api/merchant/shop/update', data })
}

// 获取店铺经营类目列表
export const getShopCategories = () => {
  return merchantApi.get({ url: '/merchant-api/merchant/shop-category/list' })
}

/** 当前套餐与额度 */
export const getCurrentPlan = (usedSpuCount?: number) => {
  return merchantApi.get({
    url: '/merchant-api/merchant/shop/plan/current',
    params: usedSpuCount != null ? { usedSpuCount } : {}
  })
}

/** 可升档套餐列表 */
export const getUpgradeOptions = () => {
  return merchantApi.get({ url: '/merchant-api/merchant/shop/plan/upgrade-options' })
}

/** 自助升档 */
export const upgradePlan = (planId: number) => {
  return merchantApi.post({ url: '/merchant-api/merchant/shop/plan/upgrade', data: { planId } })
}

/** 同步升档支付 */
export const syncPlanPay = (payOrderId: number) => {
  return merchantApi.post({
    url: '/merchant-api/merchant/shop/plan/sync-pay',
    params: { payOrderId }
  })
}
